<template>
  <v-layout>
    <v-flex xs12>
    <v-card class="mt-2" width="100%">
      <v-card-title>
      <v-dialog v-model="dialog" max-width="500px">
        <v-btn color="primary" dark slot="activator" class="mb-2">New Customer</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click.native="save" :disabled="!newCustomerValid">Save</v-btn>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-form ref="newCustomer" v-model="newCustomerValid">
                  <v-text-field 
                    label="Customer Name" 
                    v-model="editedItem.customerName"
                    :rules="[v => !!v || 'Name is required']" 
                    required>
                  </v-text-field>
                  <v-text-field 
                    label="Short Name" 
                    v-model="editedItem.shortName"
                    :rules="[v => !!v || 'Short Name is required']" 
                    required
                    v-show="editedIndex < 0"
                    hint="This is used as a prefix for project and job numbers">
                  </v-text-field>
                  <v-text-field 
                    label="Customer No." 
                    v-model="editedItem.customerNumber"
                    hint="Customer Number Normally first 3 letters of name followed by 3 numbers">
                  </v-text-field>
                  <v-combobox 
                    label="Select BDM User"
                    :items="bdmUsers"
                    item-text="Name"
                    v-model="BDMSelect"
                    return-object
                    clearable>
                  </v-combobox>
                  <v-text-field 
                    label="BDM Name" 
                    v-model="editedItem.BDM">
                  </v-text-field>
                  <v-text-field 
                    type="email"
                    label="BDM Email" 
                    v-model="editedItem.BDMEmail">
                  </v-text-field>
                  <v-combobox 
                    label="Select Desk Manager User"
                    :items="dbamUsers"
                    item-text="Name"
                    v-model="DMSelect"
                    return-object
                    clearable>
                  </v-combobox>
                  <v-text-field 
                    label="Desk Manager Name" 
                    v-model="editedItem.DeskManager">
                  </v-text-field>
                  <v-text-field 
                    type="email"
                    label="Desk Manager Email" 
                    v-model="editedItem.DeskManagerEmail">
                  </v-text-field>
                  </v-form>
                  <v-list>
                    <v-subheader>Sites
                      <v-spacer></v-spacer>
                      <v-btn :disabled="editedItem.id === undefined" small color="primary" @click="selectedSiteKey = null; siteDialog = true">Add Site<v-icon>add_location</v-icon></v-btn>
                    </v-subheader>
                    <v-list-tile avatar v-for="site in sites" :key="site.id" @click="selectedSiteKey = site.id; siteDialog = true">
                      <v-list-tile-avatar>
                        <v-icon>place</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="site.Name"></v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="customers"
        :search="search"
        item-key="id"
        :loading="tableLoading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td  @click.stop="editItem(props.item)">{{ props.item.customerName }}</td>
          <td  @click.stop="editItem(props.item)">{{ props.item.customerNumber || '' }}</td>
          <td class="text-xs-right">
            <v-btn icon class="mx-0" @click.stop="deleteItem(props.item)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
    </v-flex>
    <site-edit-dialog @getSites="refreshSites" @setCustomer="updateCustomer" :customer="editedItem" :customers="customerObj" :siteDialog.sync="siteDialog" :siteID="selectedSiteKey"></site-edit-dialog>
  </v-layout>
</template>

<script>
import { fireStore } from '../../firebase'
export default {
  data () {
    return {
      expanded: false,
      newCustomerValid: false,
      customers: [],
      customerObj: {},
      selectedSiteKey: '',
      headers: [
        {
          text: 'Name',
          value: 'customerName',
          align: 'left'
        },
        {
          text: 'Number',
          value: 'customerNumber',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'Actions',
          align: 'right',
          sortable: false
        }
      ],
      search: '',
      dialog: false,
      siteDialog: false,
      editedIndex: -1,
      engineers: [],
      sites: [],
      tableLoading: false,
      editedItem: {
        customerName: '',
        shortName: ''
      },
      defaultItem: {
        customerName: '',
        shortName: ''
      },
      pagination: {
        sortBy: 'customerName',
        rowsPerPage: 25,
        page: 1,
        descending: false
      },
      users: [],
      BDMSelect: null,
      DMSelect: null,
      dbamUsers: [
        {
          Name: 'Erin Donnelly',
          Email: 'e.donnelly@nibc.co.uk'
        },
        {
          Name: 'Victoria McDonald',
          Email: 'v.carnahan@nibc.co.uk'
        },
        {
          Name: 'Sion Liebig',
          Email: 's.liebig@nibc.co.uk'
        },
        {
          Name: 'Odrhan Totten',
          Email: 'o.totten@nibc.co.uk'
        },
        {
          Name: 'Lee Thompson',
          Email: 'l.thompson@nibc.co.uk '
        }
      ],
      bdmUsers: [
        {
          Name: 'Conor Patton',
          Email: 'c.patton@nibc.co.uk'
        },
        {
          Name: 'Craig Marsden',
          Email: 'c.marsden@nibc.co.uk'
        },
        {
          Name: 'Elizabeth Vuagniaux',
          Email: 'e.vuagniaux@nibc.co.uk '
        },
        {
          Name: 'Phil Cowen',
          Email: 'p.cowen@nibc.co.uk'
        },
        {
          Name: 'Geoff Reid',
          Email: 'g.reid@nibc.co.uk'
        },
        {
          Name: 'Phil Elwood',
          Email: 'p.elwood@nibc.co.uk'
        },
        {
          Name: 'Gary Wilson',
          Email: 'g.wilson@nibc.co.uk '
        },
        {
          Name: 'Douglas Higgins',
          Email: 'douglas@wearecubo.com'
        },
        {
          Name: 'Lucy Penman',
          Email: 'l.penman@nibc.co.uk'
        },
        {
          Name: 'Lee Thompson',
          Email: 'l.thompson@nibc.co.uk'
        },
        {
          Name: 'Alastair Protheroe',
          Email: 'alastair@wearecubo.com'
        },
        {
          Name: 'Robert Steele',
          Email: 'r.steele@nibc.co.uk'
        }
      ]
    }
  },
  created () {
    this.getCustomers()
    fireStore.collection('Users').get()
    .then(snap => {
      snap.forEach(doc => {
        this.users.push(doc.data())
      })
    })
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Customer' : 'Edit Customer'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    BDMSelect (val) {
      if (val) {
        if (typeof val === 'object') {
          console.log(val)
          if (val.Email && val.Name) {
            this.editedItem.BDM = val.Name
            this.editedItem.BDMEmail = val.Email
          } else {
            this.editedItem.BDM = null
            this.editedItem.BDMEmail = null
          }
        }
      } else {
        this.editedItem.BDM = null
        this.editedItem.BDMEmail = null
      }
    },
    DMSelect (val) {
      if (val) {
        if (typeof val === 'object') {
          console.log(val)
          if (val.Email && val.Name) {
            this.editedItem.DeskManager = val.Name
            this.editedItem.DeskManagerEmail = val.Email
          } else {
            this.editedItem.DeskManager = null
            this.editedItem.DeskManagerEmail = null
          }
        }
      } else {
        this.editedItem.DeskManager = null
        this.editedItem.DeskManagerEmail = null
      }
    },
    editedIndex (val) {
      this.customerObj = {}
      this.customerObj[this.editedItem.id] = this.editedItem
    }
  },
  methods: {
    updateCustomer (customerObj) {
      this.customerObj[this.editedItem.id].headOffice = customerObj.headOffice
    },
    getCustomers () {
      this.tableLoading = true
      this.customers = []
      fireStore.collection('Customers').get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.customers.push(data)
          this.tableLoading = false
        })
      })
    },
    editItem (item) {
      this.editedIndex = this.customers.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.refreshSites()
      this.dialog = true
    },
    refreshSites () {
      this.sites = []
      fireStore.collection('Sites').where('Customer', '==', this.editedItem.id)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.sites.push(data)
        })
      })
    },
    deleteItem (item) {
      const index = this.customers.indexOf(item)
      confirm('Are you sure you want to delete this item?') && fireStore.collection('Customers').doc(item.id).delete().then(() => { this.customers.splice(index, 1) })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.DMSelect = null
        this.BDMSelect = null
        this.sites = []
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        fireStore.collection('Customers').doc(this.editedItem.id).set(this.editedItem, {merge: true})
        .then(() => {
          Object.assign(this.customers[this.editedIndex], this.editedItem)
          this.close()
        })
      } else {
        fireStore.collection('Customers').add(this.editedItem)
        .then((docRef) => {
          this.editedItem.id = docRef.id
          this.customers.push(this.editedItem)
          this.editedIndex = this.customers.length - 1
          // this.close()
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Customer.vue?55163796